import { Twitter, Youtube, Instagram, Linkedin } from "lucide-react";
import { scrollToId } from "@/lib/ui";

const COLS = [
  {
    title: "PRODUCT",
    links: [
      { label: "P.E.E. Game Plan", id: "framework" },
      { label: "P.E.E. OS", id: "pee-os" },
      { label: "Analytics", id: "analytics" },
      { label: "Training", id: "training" },
      { label: "Pricing", id: "pricing" },
    ],
  },
  {
    title: "COMMUNITY",
    links: [
      { label: "Execution Traders", id: "community" },
      { label: "Results", id: "results" },
      { label: "Resources", id: "community" },
      { label: "Support", id: "faq" },
    ],
  },
  {
    title: "COMPANY",
    links: [
      { label: "About", id: "why-pee" },
      { label: "Contact", id: "faq" },
    ],
  },
  {
    title: "LEGAL",
    links: [
      { label: "Terms", id: "legal" },
      { label: "Privacy", id: "legal" },
      { label: "Risk Disclosure", id: "legal" },
      { label: "Refund Policy", id: "legal" },
    ],
  },
];

const SOCIALS = [
  { icon: Twitter, label: "X / Twitter" },
  { icon: Youtube, label: "YouTube" },
  { icon: Instagram, label: "Instagram" },
  { icon: Linkedin, label: "LinkedIn" },
];

export default function FooterV2() {
  return (
    <footer data-testid="footer" className="border-t border-line bg-[#040404]">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_2fr]">
          <div>
            <div className="flex items-center gap-2 font-display text-4xl font-extrabold tracking-tight text-white">
              P.E.E. OS™
              <span className="pulse-dot mt-2 h-2 w-2 rounded-full bg-neon" />
            </div>
            <div className="mt-4 font-mono text-[11px] uppercase tracking-[0.3em] text-neon/90">
              Execution Over Everything.™
            </div>
            <div className="mt-8 flex gap-3">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  href="#"
                  onClick={(e) => e.preventDefault()}
                  aria-label={s.label}
                  data-testid={`footer-social-${s.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
                  className="flex h-10 w-10 items-center justify-center rounded-md border border-line text-mist transition-colors duration-300 hover:border-neon/50 hover:text-neon"
                >
                  <s.icon size={16} />
                </a>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-10 sm:grid-cols-4">
            {COLS.map((c) => (
              <div key={c.title}>
                <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-dim">
                  {c.title}
                </div>
                <ul className="mt-5 space-y-3">
                  {c.links.map((l) => (
                    <li key={l.label}>
                      <button
                        data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
                        onClick={() => l.id !== "legal" && scrollToId(l.id)}
                        className="text-left text-sm text-mist transition-colors duration-300 hover:text-neon"
                      >
                        {l.label}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div
          id="legal"
          data-testid="footer-risk-disclosure"
          className="mt-16 rounded-lg border border-line bg-charcoal/60 p-6 sm:p-8"
        >
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-mist">
            Risk Disclosure
          </div>
          <p className="mt-4 text-xs leading-relaxed text-dim">
            Trading futures and other financial instruments involves substantial
            risk and is not suitable for every investor. You may lose some or
            all of the capital used for trading. Past performance does not
            guarantee future results. P.E.E. OS™, the P.E.E. Game Plan,
            Execution Traders Community, educational materials, alerts,
            analytics, coaching, and related resources do not guarantee
            profitable trades or future trading results. Examples,
            demonstrations, testimonials, and case studies should not be
            interpreted as promises of future performance. Users remain
            responsible for their own trading decisions and risk management.
            Educational content is provided for informational purposes.
          </p>
          <p className="mt-3 font-mono text-[9px] uppercase tracking-[0.2em] text-dim/70">
            Subject to final professional legal review before commercial launch.
          </p>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-4 border-t border-line pt-8 sm:flex-row sm:items-center">
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-dim">
            © 2026 Execution Traders Community — All rights reserved
          </span>
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-dim">
            P.E.E. OS™ · Position • Event • Entry
          </span>
        </div>
      </div>
    </footer>
  );
}
